import url from 'libraries/front-end-core/core/url'
import { Controller } from 'libraries/front-end-core/core/Router'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import { QA_REVIEW } from 'constants/controllers'

export default new Controller({
  name: 'LegacyQaReviewRedirect',
  route: ':aol/qareview/:flavour/:sectionId/:selectedIds',
  controller (Router, { params, query }) {
    const target = url(QA_REVIEW, params, query)
    replaceUrl(target)
  }
})
